import React from 'react';
import './app.css';
import Routes from './Routes';

function App() {
  return (
    <Routes />
  );
}

export default App;
